import logo from "../images/logo_sm.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

export const SiteNav = () => {
    const path = window.location.pathname.replace("/", "");
    const pathName = !path ? "index" : path;

    return (
        <Navbar expand="lg" variant={pathName === "index" ? "dark" : "light"}>
            <Container>
                <Navbar.Brand href="/">
                    <img src={logo} alt="Video is Social logo"></img>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href="/projects">Projects</Nav.Link>
                        <Nav.Link href="/contact">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};
